import { AxiosInstance } from 'axios';
import axiosClient from './axiosClientConfig';
import { HttpResponse, VenmoAccount } from '@/interfaces';

class PaymentService {
	constructor(private client: AxiosInstance) {}

	async getPaypal(): Promise<HttpResponse<{ paypalAccount: string }>> {
		return this.client.get(`/paypal`);
	}

	async updatePaypal(
		email: string
	): Promise<HttpResponse<{ message: string }>> {
		return this.client.patch(`/paypal`, { paypalEmailAccount: email });
	}

	async deletePaypal(): Promise<HttpResponse<{ message: string }>> {
		return this.client.delete(`/paypal`);
	}

	async getVenmo(): Promise<HttpResponse<VenmoAccount>> {
		return this.client.get(`/venmo`);
	}

	async createVenmo(
		data: Partial<VenmoAccount>
	): Promise<HttpResponse<{ message: string }>> {
		return this.client.post(`/venmo`, data);
	}

	async updateVenmo(
		data: Partial<VenmoAccount>
	): Promise<HttpResponse<{ message: string }>> {
		return this.client.put(`/venmo`, data);
	}

	async deleteVenmo(): Promise<HttpResponse<{ message: string }>> {
		return this.client.delete(`/venmo`);
	}
}

export const paymentService = new PaymentService(axiosClient);
